import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import style from './ItemTitle.css'

/**
 * Item Title is the primary line of text in an [Item](/components/item/).
 *
 * @status draft
 * @category list
 * @lightDom true
 *
 * @slot - Default slot for the title text (and optionally an inline icon).
 */
@customElement('nord-item-title')
export default class ItemTitle extends LitElement {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-item-title': ItemTitle
  }
}
